module.exports = __webpack_public_path__ + "images/event/event_cover_new.52bc3ca7bc3958f66cfa34350d81f7cb.jpg";